import { NgZone, Output, EventEmitter } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { Mode, Language } from 'src/core/utility/enums/enums';
import { BaseTranslation } from 'src/core/translation/model/translation.base';
import { IAppConfig } from 'src/config/app-config.model';
import { AppConfig } from 'src/config/app-config.service';
import { LoadingScreenService } from 'src/core/components/loader/services/loader.service';

export abstract class BaseComponent extends BaseTranslation {

    //#region Properties
    @Output()
    public callAPIEvent: EventEmitter<any> = new EventEmitter();
    @Output()
    public EndcallAPIEvent: EventEmitter<any> = new EventEmitter();

    public status: Mode = Mode.None;
    public list: any[] = [];
    public enumMode = Mode;
    public appSettings: IAppConfig;
    public currenLanguage:string;
    //#endregion

    //#region Constructor
    constructor(ngZone: NgZone , translate: TranslateService,public LoadingScreenService:LoadingScreenService) {
       super(translate,ngZone);
       this.appSettings = AppConfig.settings;
        this.currenLanguage=Language[_spPageContextInfo.currentLanguage];
       
    }
    //#endregion


    //#region Methods
    onSuccess = (data: any) => {
        //alert('base');
        this.ngZone.run(() => {
            this.LoadingScreenService.stopLoading();
            this.EndcallAPIEvent.emit();
            this.status = Mode.Success;
            this.list = data;
        });

    }

    onError = (e) => {
        console.error(e);
        this.ngZone.run(() => {
            this.LoadingScreenService.stopLoading();
            this.EndcallAPIEvent.emit();
            this.status = Mode.Error;
           
        });

    }

    onNoAvailableData = () => {
        this.ngZone.run(() => {
            this.LoadingScreenService.stopLoading();
            this.EndcallAPIEvent.emit();
            this.status = Mode.Warning;
            
        });
    }
    //#endregion
}